import { useState, useEffect } from "react";
import axios from "axios";
import API_ENDPOINTS from "config/api";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DataTable from "examples/Tables/DataTable";

export default function Documentos() {
  const [documentos, setDocumentos] = useState([]);

  useEffect(() => {
    const fetchDocumentos = async () => {
      try {
        const response = await axios.get(API_ENDPOINTS.RRHH.DOCUMENTOS);
        setDocumentos(response.data);
      } catch (error) {
        console.error("Error al cargar documentos:", error);
      }
    };
    fetchDocumentos();
  }, []);

  const getTipoColor = (tipo) => {
    switch (tipo) {
      case "Contrato":
        return "primary";
      case "Fiscal":
        return "success";
      case "Personal":
        return "info";
      case "Médico":
        return "warning";
      default:
        return "default";
    }
  };

  const getEstatusColor = (estatus) => {
    switch (estatus) {
      case "Vigente":
        return "success";
      case "Por Vencer":
        return "warning";
      case "Vencido":
        return "error";
      default:
        return "default";
    }
  };

  const columns = [
    {
      Header: "documento",
      accessor: "nombre",
      width: "30%",
    },
    {
      Header: "empleado",
      accessor: "empleado",
      width: "20%",
    },
    {
      Header: "tipo",
      accessor: "tipo",
      width: "12%",
    },
    {
      Header: "fecha",
      accessor: "fecha",
      width: "12%",
    },
    {
      Header: "tamaño",
      accessor: "tamaño",
      width: "10%",
    },
    {
      Header: "estatus",
      accessor: "estatus",
      width: "10%",
    },
    {
      Header: "acciones",
      accessor: "acciones",
      width: "10%",
    },
  ];

  const rows = documentos.map((item) => ({
    nombre: (
      <MDBox display="flex" alignItems="center">
        <Icon sx={{ mr: 1, color: "error.main" }}>picture_as_pdf</Icon>
        <MDTypography variant="caption" fontWeight="medium">
          {item.nombre}
        </MDTypography>
      </MDBox>
    ),
    empleado: <MDTypography variant="caption">{item.empleado}</MDTypography>,
    tipo: <Chip label={item.tipo} color={getTipoColor(item.tipo)} size="small" />,
    fecha: <MDTypography variant="caption">{item.fecha}</MDTypography>,
    tamaño: <MDTypography variant="caption">{item.tamaño}</MDTypography>,
    estatus: <Chip label={item.estatus} color={getEstatusColor(item.estatus)} size="small" />,
    acciones: (
      <MDBox display="flex" gap={1}>
        <MDButton variant="text" color="info" size="small" iconOnly>
          <Icon>visibility</Icon>
        </MDButton>
        <MDButton variant="text" color="success" size="small" iconOnly>
          <Icon>download</Icon>
        </MDButton>
        <MDButton variant="text" color="error" size="small" iconOnly>
          <Icon>delete</Icon>
        </MDButton>
      </MDBox>
    ),
  }));

  return (
    <MDBox>
      <Grid container spacing={3} mb={3}>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <Icon sx={{ fontSize: 48, color: "primary.main" }}>folder</Icon>
              <MDTypography variant="h6" color="text" mt={1}>
                Total Documentos
              </MDTypography>
              <MDTypography variant="h3" color="primary" fontWeight="bold">
                5
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <Icon sx={{ fontSize: 48, color: "success.main" }}>check_circle</Icon>
              <MDTypography variant="h6" color="text" mt={1}>
                Vigentes
              </MDTypography>
              <MDTypography variant="h3" color="success" fontWeight="bold">
                4
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <Icon sx={{ fontSize: 48, color: "warning.main" }}>warning</Icon>
              <MDTypography variant="h6" color="text" mt={1}>
                Por Vencer
              </MDTypography>
              <MDTypography variant="h3" color="warning" fontWeight="bold">
                1
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
        <Grid item xs={12} md={3}>
          <Card>
            <MDBox p={3} textAlign="center">
              <Icon sx={{ fontSize: 48, color: "info.main" }}>cloud_upload</Icon>
              <MDTypography variant="h6" color="text" mt={1}>
                Espacio Usado
              </MDTypography>
              <MDTypography variant="h3" color="info" fontWeight="bold">
                1.2 MB
              </MDTypography>
            </MDBox>
          </Card>
        </Grid>
      </Grid>

      <Card>
        <MDBox p={3}>
          <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={3}>
            <MDTypography variant="h6" fontWeight="medium">
              Expedientes Digitales
            </MDTypography>
            <MDButton variant="gradient" color="success">
              <Icon>upload_file</Icon>&nbsp;Subir Documento
            </MDButton>
          </MDBox>

          <DataTable
            table={{ columns, rows }}
            showTotalEntries={true}
            isSorted={true}
            noEndBorder
            entriesPerPage={true}
          />
        </MDBox>
      </Card>
    </MDBox>
  );
}
